import { ChannelListFilters } from "@/api/endpoints/channels";
import ArrowDown from "@/assets/icons/arrow-down.svg";
import ArrowUp from "@/assets/icons/arrow-up.svg";
import useSearchParams from "@/hooks/useSearchParams";

import styles from "./OrderingButton.module.css";

const OrderingButton: React.FunctionComponent<{
  label: string;
  id: string;
}> = ({ label, id }) => {
  const [{ ordering }, setSearchParams] = useSearchParams<ChannelListFilters>();

  const isAscending = ordering === id;
  const isDescending = ordering === `-${id}`;

  return (
    <th
      className={styles.orderingButton}
      onClick={() => {
        if (!isAscending && !isDescending) {
          // order descending by default
          setSearchParams({ ordering: id });
        } else if (isAscending) {
          // go from ascending to descending
          setSearchParams({ ordering: `-${id}` });
        } else if (isDescending) {
          // go from descending to ascending
          setSearchParams({ ordering: id });
        }
      }}
    >
      {label}
      {isAscending && <ArrowUp className={styles.orderingButtonIcon} />}
      {isDescending && <ArrowDown className={styles.orderingButtonIcon} />}
    </th>
  );
};

export default OrderingButton;
